import useInExperiment from '../useInExperiment';

export default function useExperimentalTheme() {
  const isInVR01Experiment = useInExperiment({
    webExperimentName: 'web_gestalt_visualrefresh',
    mwebExperimentName: 'web_gestalt_visualrefresh',
  });

  const isInCA1Experiment = useInExperiment({
    webExperimentName: 'web_gestalt_calico01',
    mwebExperimentName: 'web_gestalt_calico01',
  });

  // VR01 (hybrid theme with size-aware roundness) is now the default
  // Only disable it if CA01 is explicitly enabled
  const vr01Enabled = isInCA1Experiment ? false : true;

  return {
    MAIN: vr01Enabled || isInCA1Experiment,
    VR01: vr01Enabled,
    CA01: isInCA1Experiment,
  };
}
